"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environments = void 0;
var Environments;
(function (Environments) {
    Environments["PRODUCTION"] = "prod";
    Environments["PRE_PRODUCTION"] = "preprod";
    Environments["DEV_TEST"] = "devtest";
    Environments["DEVELOPMENT"] = "dev";
})(Environments = exports.Environments || (exports.Environments = {}));
//# sourceMappingURL=environments.js.map